import HomeScreen from './screens/HomeScreen';
import React,{useEffect,useState} from 'react'
import {ThemeProvider,createMuiTheme, } from '@mui/material/styles';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import LoadingScreen from './screens/LoadingScreen'

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
//import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

import Resume from './components/Resume';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
//import CookieBanner from './components/CookieBanner';
import ProtectedRoute from './components/ProtectedRoute';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkV66gdSFqsmsBYHWYdOIWaUpJpyOi0-0",
  authDomain: "suprith-hattikal.firebaseapp.com",
  projectId: "suprith-hattikal",
  storageBucket: "suprith-hattikal.appspot.com",
  messagingSenderId: "875405824331",
  appId: "1:875405824331:web:df9f968dcfe022d9f558ce",
  measurementId: "G-C46G0JMKYH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const THEME = createMuiTheme({
  typography: {
   "fontFamily": `"Calibre","Inter","San Francisco","SF Pro Text"`
  } ,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

function App() {
  const [loadingShown,setLoadingShown] = useState(false)
  useEffect(()=>{
    setTimeout(()=>{
      setLoadingShown(true)
    },2000)
    
  },[])
  return (
    <ThemeProvider theme={THEME}>

      
    <div className="App">
      
      {!loadingShown?

      <LoadingScreen/>

      :

      <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen/>} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin-panel"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
      }
      
    </div>
    </ThemeProvider>
  );
}

export default App;
